import { ApiProperty } from "@nestjs/swagger";

export class salordeIdandsoItemIdReq{
    @ApiProperty()
    saleOrderId:number
    @ApiProperty()
    saleOrderItemId:number
}